<template>
    <v-card
            :class="classeComputed"
            elevation="2"
            outlined
            @click="emitClick()"
            height="100%"
    >
        <v-card-title class="justify-left pl-0 endereco-card-title color-primary">
            Endereço #{{ formatedIndex }}
        </v-card-title>
        <p style="margin-top: -8px;"><span class="endereco-card-explanation">Logradouro: </span><span class="endereco-card-content">{{ endereco.Endereco }}</span></p>
        <p style="margin-top: -8px;"><span class="endereco-card-explanation">Bairro: </span><span class="endereco-card-content">{{ endereco.Bairro }}</span></p>
        <p style="margin-top: -8px;"><span class="endereco-card-content ">{{ endereco.NM_Cidade }} - {{ endereco.ID_UF }} </span></p>
    </v-card>
</template>

<script>
  import { formatToMoreThanOneDecimal } from '../plugins/helpers'
  export default {
    name: 'CardEndereco',
    props: {
      selecionado: {
        type: Boolean,
        default: false
      },
      index: Number,
      endereco: {
        type: Object,
        required: true
      },
      isResidencial: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      formatedIndex () {
        return formatToMoreThanOneDecimal(this.index + 1)
      },
      classeComputed () {
        const selecionado = this.selecionado ? 'selecionado' : ''
        return 'mx-auto px-3 hover-verde-pointer ' + selecionado
      }
    },
    mounted () {
      this.endereco.Endereco = this.endereco.Endereco.toLowerCase()
      this.endereco.Bairro = this.endereco.Bairro.toLowerCase()
      this.endereco.NM_Cidade = this.endereco.NM_Cidade.toLowerCase()
    },
    methods: {
      emitClick () {
        if (!this.selecionado) {
          this.$emit('selecionar', this.endereco, this.index, this.isResidencial)
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .selecionado{
    border: 2px solid var(--primary) !important;

  }
  .hover-verde-pointer{
    cursor:pointer;
    &:hover{
      border: 1px solid  var(--primary);
    }
  }
  .endereco-card-title{
    font-size: 1.5rem;
    font-weight: 1000;
    color: #000000;
  }
  .endereco-card-content{

    font-size: 1.1rem;
    font-weight: bolder;
    color: #747474;
    text-transform: capitalize;
  }
  .endereco-card-explanation{
    font-size: 1.2rem;
    font-weight: 400;
    color: #747474;
  }
</style>
